import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

export const getConnectors = async (teamId?: string) => {
  const userId = await getUserId();
  const payload = { p_principal_id: teamId || userId };
  const { data, error } = await supabase.rpc("get_connectors", payload);

  if (error) {
    throw error;
  }

  return data;
};

export const useConnectors = (teamId?: string) => {
  return useQuery({
    queryKey: ["connectors", teamId],
    queryFn: () => getConnectors(teamId),
    refetchOnWindowFocus: false,
  });
};
